import { useEffect } from 'react'

import { searchOptions } from 'utils/constants'
import { useData } from 'utils/context'

const useSearch = () => {
  const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g 
  const { search, dispatchSearch } = useData()
  const { error='', term='', input='', type=searchOptions[0].value, previous='' } = search ?? {}
  const setError = (errorString) => dispatchSearch({ error: errorString })
  const clearError = () => dispatchSearch({ error: '' })
  const setTerm = (typeString) => dispatchSearch({ term: typeString })
  const setInput = (typeString) => dispatchSearch({ input: typeString })
  const setPrevious = (typeString) => dispatchSearch({ previous: typeString })
  const setType = (typeString) => dispatchSearch({ type: typeString })
  
  const clear = () => {
    setInput('')
    setTerm('')
  }
  const trigger = () => {
    setTerm(input)
  }
  const validate = (term) => {
    if (type === searchOptions[1].value && term !== '' && !phoneRegex.test(term)) {
      setError('Enter a valid phone number')
    } else {
      clearError()
    }
  }
  useEffect(() => {
    validate(term)
  }, [type, term])
  return {
    error,
    previous,
    input,
    term,
    type,
    clear,
    clearError,
    setError,
    setInput,
    setPrevious,
    setTerm,
    setType,
    trigger,
    validate
  }
}

export default useSearch
